<template>
  <button
    v-click-outside="closeShare"
    :class="['mobile-share', { active: mobileShare }]"
    @click="mobileShare = !mobileShare"
  >
    <span>поделиться</span>
    <img
      src="../../../assets/images/i-share.svg"
      alt="поделиться"
    >

    <slot v-if="mobileShare" />

    <button
      v-if="mobileShare"
      class="mobile-share__close"
      @click.stop="mobileShare = false"
    >
      <img
        src="../../../assets/images/material-close.svg"
        alt="close"
      >
    </button>
  </button>
</template>

<script>
import vClickOutside from 'v-click-outside';

export default {
  name: 'MaterialShareMobile',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    tablet: { type: Boolean, default: false },
  },
  data: () => ({
    mobileShare: false,
  }),
  methods: {
    closeShare() {
      if (this.tablet && window.innerWidth >= 768) {
        this.mobileShare = false;
      }

      if (!this.tablet && window.innerWidth < 768) {
        this.mobileShare = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">

.mobile-share {
  position: relative;
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: calc(var(--scale) * 4);

  span {
    font-weight: 500;
    font-size: calc(var(--scale) * 14);
    line-height: 130%;
    color: #A7ABAC;
  }

  img {
    filter: invert(72%) sepia(9%) saturate(86%) hue-rotate(145deg) brightness(92%) contrast(94%);
  }

  &__close {
    position: absolute;
    z-index: 2;
    top: calc(var(--scale) * 50);
    right: calc(var(--scale) * 10);
    padding: 0;
    border: none;
    background: none;
    outline: none;
    cursor: pointer;

    img {
      width: calc(var(--scale) * 40);
      height: calc(var(--scale) * 40);
      filter: none !important;
    }
  }

  &.active {
    span {
      color: #5237E6;
    }

    img {
      filter: invert(23%) sepia(87%) saturate(6204%) hue-rotate(249deg) brightness(93%) contrast(94%);
    }
  }

  .material-share {
    padding: calc(var(--scale) * 10) calc(var(--scale) * 47) calc(var(--scale) * 10) calc(var(--scale) * 10);
    justify-content: flex-start;
    width: calc(var(--scale) * 280);
    position: absolute;
    right: 0;
    top: calc(var(--scale) * 40);
    background-color: #FFFFFF;
    box-shadow: 0 calc(var(--scale) * 1) calc(var(--scale) * 24) rgba(0, 62, 135, 0.2);
    border-radius: calc(var(--scale) * 20);

    ::v-deep(span) {
      display: none !important;
    }
  }
}

</style>
